"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4802],{

/***/ 4802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ AdMgid; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _components_Layout_WrapperContent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3078);
/* harmony import */ var _hooks_useScriptFlag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1436);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);






function AdMgid(param) {
    var type = param.type;
    var ref, ref1;
    var variants = {
        mobile: "desktop:hidden flex",
        desktop: "desktop:flex hidden"
    };
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var shouldRenderAds = (0,_hooks_useScriptFlag__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        adFlag: "mgid"
    });
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), shouldRender = ref2[0], setShouldRender = ref2[1];
    var mgIdScript = type === "mobile" ? "1536993" : "1525795";
    var scriptTimer = !Number.isNaN(Number((ref = router.query) === null || ref === void 0 ? void 0 : ref.timer)) ? Number((ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.timer) : 5000;
    var appendScript = function() {
        setTimeout(function() {
            setShouldRender(true);
        }, scriptTimer);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (shouldRenderAds) appendScript();
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_WrapperContent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        mobileOnly: type === "mobile",
        desktopOnly: type === "desktop",
        className: "desktop:mb-[90px]",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: variants[type],
            id: "mgidContainerCT".concat(type),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    "data-type": "_mgwidget",
                    "data-widget-id": mgIdScript
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_4___default()), {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: shouldRender && function(w, q) {
                            w[q] = w[q] || [];
                            w[q].push([
                                "_mgc.load"
                            ]);
                        }(window, "_mgq")
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 1080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9659);


function Container(param) {
    var children = param.children, _hasBreadcrumb = param.hasBreadcrumb, hasBreadcrumb = _hasBreadcrumb === void 0 ? false : _hasBreadcrumb, _className = param.className, className = _className === void 0 ? "" : _className;
    var variants = {
        hasBreadcrumb: {
            true: "mt-4 desktop:mt-10",
            false: ""
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("w-full max-w-[calc(100%-2rem)] desktop:max-w-[83.33%]", variants.hasBreadcrumb[hasBreadcrumb.toString()], className),
        children: children
    });
}


/***/ }),

/***/ 3078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WrapperContent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1080);
/* harmony import */ var _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9642);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9659);




function WrapperContent(param) {
    var children = param.children, backgroundColor = param.backgroundColor, _isOnHeader = param.isOnHeader, isOnHeader = _isOnHeader === void 0 ? false : _isOnHeader, _paddingOnBottom = param.paddingOnBottom, paddingOnBottom = _paddingOnBottom === void 0 ? false : _paddingOnBottom, _paddingOnTop = param.paddingOnTop, paddingOnTop = _paddingOnTop === void 0 ? false : _paddingOnTop, _hasBreadcrumb = param.hasBreadcrumb, hasBreadcrumb = _hasBreadcrumb === void 0 ? false : _hasBreadcrumb, _mobileOnly = param.mobileOnly, mobileOnly = _mobileOnly === void 0 ? false : _mobileOnly, _desktopOnly = param.desktopOnly, desktopOnly = _desktopOnly === void 0 ? false : _desktopOnly, _className = param.className, className = _className === void 0 ? undefined : _className;
    var variants = {
        isOnHeader: {
            true: "isOnHeader [&.isOnHeader]:p-0",
            false: ""
        },
        paddingOnBottom: {
            true: "paddingOnBottom [&.paddingOnBottom]:pb-10",
            false: "pb-0"
        },
        paddingOnTop: {
            true: "paddingOnTop [&.paddingOnTop]:pt-10",
            false: ""
        },
        mobileOnly: {
            true: "flex desktop:hidden",
            false: ""
        },
        desktopOnly: {
            true: "hidden desktop:flex",
            false: ""
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        style: {
            backgroundColor: backgroundColor || _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__/* .mglGray.mglGray50 */ .Ce.mglGray50
        },
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("relative flex w-full flex-col flex-wrap content-center justify-center px-0 py-10", variants.isOnHeader[isOnHeader.toString()], variants.paddingOnBottom[paddingOnBottom.toString()], variants.paddingOnTop[paddingOnTop.toString()], variants.mobileOnly[mobileOnly.toString()], variants.desktopOnly[desktopOnly.toString()]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            hasBreadcrumb: hasBreadcrumb,
            className: className,
            children: children
        })
    });
}


/***/ })

}]);